<app-admin-list-page [title]="'Teacher profiles' | translate">

  <h3>{{'Results' | translate}}</h3>
  <app-table [config]="configTable" (buttonEvent)="handleButtonEvent($event)"></app-table>

</app-admin-list-page>
